export default function getRole(userObject) {
  let roleList = ["developer","owner", "user"]
  let roleDetail = {
    "developer": ["isAdmin",  "isDeveloper", "isDocsReader", "isDocsWriter", "isGraphReader", "isPaymentAdmin"],
    "owner": ["isAdmin", "isDocsReader", "isDocsWriter", "isGraphReader", "isPaymentAdmin"],
    "user": ["isDocsReader", "isDocsWriter", "isGraphReader"],
  }

  for (let indexRole = 0; indexRole < roleList.length; indexRole++) {
    let roleKey = roleList[indexRole]
    let role = roleDetail[roleKey]
    let countCheckRole = 0
    for (let i = 0; i < role.length; i++) {
      let detail = role[i]
      if (userObject[detail] === true) {
        countCheckRole++;
      }
    }
    if (countCheckRole === role.length) {
      return roleKey
    }
  }
  return "-"
}
